import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { MediaModel } from "../../models/media.model";
import { UploadFile } from "antd/lib";
import { RcFile } from "antd/es/upload";
import { MultipleOpsResult } from "@/core/models/response.model";

interface _MediaGetParams {
    search?: string;
}

@injectable()
export class MediaRepo extends TableRepo<MediaModel> {
    constructor() {
        super("/api/Media");
    }

    async getData(index: number, params: _MediaGetParams, pageSize = 10): Promise<ApiPage<MediaModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async upload(model: MediaModel, file: RcFile) {
        try {
            const formData = new FormData();
            formData.append("Name",  file.name);
            formData.append("File", file as File);
            formData.append("ObjectType", model.objectType);
            formData.append("ReferenceId", model.referenceId);
            const response = await this.apiRepo.postMultipart(`${this.basepath}/add`, formData);
                if (response?.code === '00') {
                    this.changes.next(Date.now());
                    return true
                };
            return false;
        } catch (err) {
            console.log(err);
            return false;
        }
    }

    async list(objectType: string, referenceId: string) {
        try {
            const response = await this.apiRepo.get<ApiPage<MediaModel>>(`${this.basepath}/${this.getAllPath}`, {objectType, referenceId});
            if (response?.code === '00') {
                return response.result.data
            };
        } catch (err) {
            console.log(err);
        }
        return [];
    }

    async deleteFiles(ids: string[]): Promise<MultipleOpsResult> {
        let success = 0;
        const responses = await Promise.all(ids.map(id => this.apiRepo.post(`${this.basepath}/${this.deletePath}`, {id: id})));
        responses.forEach(response => {
            if (response?.code === '00') {
                success++;
            }
        })
        if (success > 0) {
            this.changes.next(Date.now());
        }
        return {success, total: ids.length};
    }

}